import moment from "moment";
import { log } from "../utils/logger";

export default function generateCampaigns({ SAMPLE_RECORD_COUNT = 100 } = {}) {
  log(`%c[+] Generating [${SAMPLE_RECORD_COUNT}] mock[CAMPAIGNS]`, "color:green");

  // Exported Array
  const SAMPLE_DATA = [];

  // Generator configs
  // 0=editing, 1=scheduled, 2=launched, 3=completed, -1=paused, 4=waiting for approval
  const SAMPLE_STATUSES = {
    "-2": "error",
    "-1": "paused",
    1: "scheduled",
    0: "editing",
    2: "launched",
    3: "completed",
    4: "waiting",
  };

  for (let i = 0; i < SAMPLE_RECORD_COUNT; i++) {
    const status_int = Math.round(Math.random() * (Object.keys(SAMPLE_STATUSES).length - 1) - 2);
    const status_vch = SAMPLE_STATUSES[status_int];

    const sample_record = {
      campaign_id_bint: i,
      title_vch: `Sample ${i}`,
      created_dt: moment()
        .subtract(Math.round(Math.random() * 50), "d")
        .toDate(),
      scheduled_at: new Date(),
      _created_by: "Sample Data",
      status_int: status_int,
      _status_vch: status_vch,
      stats: {
        email: {},
        sms: {},
        voice: {},
      },
    };

    const email_count = Math.round(Math.random() * 100) + 100;
    const statuses = {
      email: ["delivered", "opened", "clicked", "dropped", "bounced", "duplicates", "error"],
      sms: ["delivered", "not_delivered", "opt_out", "duplicate", "error"],
      voice: [
        "live",
        "busy",
        "machine",
        "no_answer",
        "live_agent_transfer",
        "duplicate",
        "error",
        "other",
      ],
    };

    ["email", "sms", "voice"].forEach((type) => {
      for (let i = 0; i < email_count; i++) {
        let status = statuses[type][Math.ciel(Math.random() * statuses.email.length - 1)];

        let status_record = sample_record.stats[type].find(({ result }) => result === status);
        if (!status_record) {
          sample_record.stats[type].push({ type: "email", result: status, count: 1 });
        } else {
          status_record.count++;
        }
      }
    });

    SAMPLE_DATA.push(sample_record);
  }

  return SAMPLE_DATA;
}
